import { render, staticRenderFns } from "./WorkflowRemoveStatusCategory.vue?vue&type=template&id=104cac1a&scoped=true"
import script from "./WorkflowRemoveStatusCategory.vue?vue&type=script&lang=js"
export * from "./WorkflowRemoveStatusCategory.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRemoveStatusCategory.vue?vue&type=style&index=0&id=104cac1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104cac1a",
  null
  
)

export default component.exports